import { useQuery } from 'react-query';

import { getV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatus } from 'src/client/spendesk-api';

export const useWireFundsOutRequestRefetched = (
  shouldRefresh: boolean,
  withdrawalId: string | null,
  companyId: string,
) => {
  return useQuery(
    ['withdrawalStatus', withdrawalId ?? ''],
    async () => {
      const response =
        await getV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatus({
          path: { companyId, withdrawalId: withdrawalId ?? '' },
        });
      if (response.statusCode === 200) {
        return response.body.data;
      }
      throw new Error('Failed to fetch wire funds out status');
    },
    {
      enabled: Boolean(withdrawalId),
      refetchInterval: shouldRefresh ? 1000 : false,
    },
  );
};
